import React, { useState } from 'react';
import { AdminUserListBulkEditModalContainer } from '../../../themes/Pages/UserManagement/AdminUserListBulkEditModalTheme';
import { GrClose } from 'react-icons/gr';
import { updateAdminUsers } from '../../../api/UserManagement/adminUserList';
import { useNavigate, useOutletContext } from 'react-router-dom';

const AdminUserListBulkEditModal = ({ selectedUsers, setOpenBulkEditModal, adminMemberTypeList, setNotificationMessage, setNotificationType, setIsNotificationOpen }) => {

    const navigate = useNavigate();
    const { accessTypeList } = useOutletContext();
    const [selectedMemberType, setSelectedMemberType] = useState('');
    const [selectedAccessType, setSelectedAccessType] = useState('');

    const handleApply = async () => {

        const userDataArray = selectedUsers.map(user => ({
            ...user,
            adminMemberTypeCode: selectedMemberType,
            accessTypeCode: selectedAccessType
        }));

        try {
            const response = await updateAdminUsers(navigate, userDataArray);
            if (response) {
                setOpenBulkEditModal(false);
                setNotificationMessage('ユーザーの更新に成功しました');
                setNotificationType('success');
                setIsNotificationOpen(true);
                localStorage.setItem('notificationMessage', response.message);
                window.location.reload();
            }
        } catch (error) {
            navigate('/error', { state: { statusCode: '', errorMessage: 'ユーザーの更新に失敗しました' } });
        }
    }


    return (
        <AdminUserListBulkEditModalContainer>
            <div className='AdminUserListBulkEditModalContent'>
                <button className='CloseButton' onClick={() => setOpenBulkEditModal(false)}>
                    <GrClose />
                </button>
                {selectedUsers.length === 0 ? (
                    <div className='AdminUserListBulkEditModalEmpty'>
                        <div className='AdminUserListBulkEditModalEmptyTitle'>選択されていません</div>
                        <div className='AdminUserListBulkEditModalEmptyDescription'>一括編集するユーザーを選択してください。</div>
                    </div>
                ) : (
                    <>
                        <div className='AdminUserListBulkEditModalHeader'>
                            <div className='AdminUserListBulkEditModalHeaderTitle'>一括編集</div>
                            <div className='AdminUserListBulkEditModalHeaderDescription'>下記のユーザーを一括編集します。</div>
                        </div>
                        <div className='AdminUserListBulkEditModalBody'>
                            <div className='AdminUserListBulkEditModalBodyHeader'>
                                <div className='userNameHeader userName'>氏名</div>
                                <div className='userEmailHeader userEmail'>メールアドレス</div>
                                <div className='memberTypeHeader memberType'>会員区分</div>
                                <div className='accessTypeHeader accessType'>アクセス区分</div>
                            </div>
                            <div className='AdminUserListBulkEditModalBodyContent'>
                                {selectedUsers.map(user => (
                                    <div className='user' key={user.id}>
                                        <div className='userName'>{user.adminUserLastName} {user.adminUserFirstName}</div>
                                        <div className='userEmail'>{user.mail}</div>
                                        <div className='memberType'>{adminMemberTypeList.find(type => type.adminMemberTypeCode === user.adminMemberTypeCode)?.adminMemberTypeName}</div>
                                        <div className='accessType'>{accessTypeList.find(type => type.accessTypeCode === user.accessTypeCode)?.accessTypeName}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className='AdminUserListBulkEditModalButton'>
                            <select className='selectMemberType' onChange={(e) => setSelectedMemberType(e.target.value)}>
                                <option value=''>会員区分を選択してください</option>
                                {adminMemberTypeList.map(adminMemberType => (
                                    <option key={adminMemberType.adminMemberTypeCode} value={adminMemberType.adminMemberTypeCode}>{adminMemberType.adminMemberTypeName}</option>
                                ))}
                            </select>
                            <select className='selectAccessType' onChange={(e) => setSelectedAccessType(e.target.value)}>
                                <option value=''>アクセス区分を選択してください</option>
                                {accessTypeList.map(accessType => (
                                    <option key={accessType.accessTypeCode} value={accessType.accessTypeCode}>{accessType.accessTypeName}</option>
                                ))}
                            </select>
                            <div className='ActionContainer'>
                                <button className='AdminUserListBulkEditModalButtonCancel' onClick={() => setOpenBulkEditModal(false)}>キャンセル</button>
                                <button className='AdminUserListBulkEditModalButtonApply' disabled={selectedMemberType === '' && selectedAccessType === ''} onClick={handleApply}>適用</button>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </AdminUserListBulkEditModalContainer>
    );
};

export default AdminUserListBulkEditModal;
